// Pieces the task page's re-plan and update dialogs share: the problem line (role=alert, so a
// refusal from the API is read out) and the Cancel / submit buttons, disabled while saving (§5.5).
import type { TaskWriter } from './use-task-writer.ts';

export function ProblemText(props: { readonly problem: string | null }): React.JSX.Element | null {
  if (props.problem === null) return null;
  return (
    <p className="field__error" role="alert">
      {props.problem}
    </p>
  );
}

export function DialogActions(props: {
  readonly writer: TaskWriter;
  readonly onCancel: () => void;
  readonly submitLabel: string;
  /** Extra buttons between Cancel and the submit button. */
  readonly children?: React.ReactNode;
  readonly submitDisabled?: boolean;
}): React.JSX.Element {
  const { writer } = props;
  return (
    <div className="modal__actions">
      <button
        type="button"
        className="btn btn--secondary"
        onClick={props.onCancel}
        disabled={writer.pending}
      >
        Cancel
      </button>
      {props.children}
      <button
        type="submit"
        className="btn btn--primary"
        disabled={writer.pending || props.submitDisabled === true}
        aria-busy={writer.pending}
      >
        {writer.pending ? 'Saving…' : props.submitLabel}
      </button>
    </div>
  );
}
